import styled from 'styled-components';

const TextLight = styled.div`
  color: ${({ theme }) => theme.colors.textLight};
`;

export default TextLight;
